import React from 'react';

const ChangeInfoIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 15.1667H2C1.72667 15.1667 1.5 14.94 1.5 14.6667C1.5 14.3933 1.72667 14.1667 2 14.1667H14C14.2733 14.1667 14.5 14.3933 14.5 14.6667C14.5 14.94 14.2733 15.1667 14 15.1667Z"
      fill="#292D32"
    />
    <path
      d="M12.6799 2.82C11.3866 1.52667 10.1199 1.49334 8.79322 2.82L7.98655 3.62667C7.91989 3.69334 7.89322 3.8 7.91989 3.89334C8.42655 5.66 9.83989 7.07334 11.6066 7.58C11.6332 7.58667 11.6599 7.59334 11.6866 7.59334C11.7599 7.59334 11.8266 7.56667 11.8799 7.51334L12.6799 6.70667C13.3399 6.05334 13.6599 5.42 13.6599 4.78C13.6666 4.12 13.3466 3.48 12.6799 2.82Z"
      fill="#292D32"
    />
    <path
      d="M10.4066 8.18667C10.2132 8.09334 10.0266 8.00001 9.84655 7.89334C9.69989 7.80667 9.55989 7.71334 9.41989 7.61334C9.30655 7.54001 9.17322 7.43334 9.04655 7.32667C9.03322 7.32001 8.98655 7.28001 8.93322 7.22667C8.71322 7.04001 8.46655 6.80001 8.24655 6.53334C8.22655 6.52001 8.19322 6.47334 8.14655 6.41334C8.07989 6.33334 7.96655 6.20001 7.86655 6.04667C7.78655 5.94667 7.69322 5.80001 7.60655 5.65334C7.49989 5.47334 7.40655 5.29334 7.31322 5.10667C7.19085 4.84445 6.84668 4.76655 6.64206 4.97117L2.89322 8.72001C2.80655 8.80667 2.72655 8.97334 2.70655 9.08667L2.34655 11.64C2.27989 12.0933 2.40655 12.52 2.68655 12.8067C2.92655 13.04 3.25989 13.1667 3.61989 13.1667C3.69989 13.1667 3.77989 13.16 3.85989 13.1467L6.41989 12.7867C6.53989 12.7667 6.70655 12.6867 6.78655 12.6L10.5416 8.84498C10.7421 8.64445 10.6668 8.29943 10.4066 8.18667Z"
      fill="#292D32"
    />
  </svg>
);

export default ChangeInfoIcon;
